import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import Text from 'components/common/Text'
import { _isTeacher } from 'store/selectors/User'

import * as Styles from './styles'

import { assetsBase, choiceOptionMap } from '../constants'
import MathJaxComponent from '../MathJaxComponent'

const Choice = ({
    isCorrect,
    numParticipantsSelected,
    totalParticipants,
    content,
    option,
    isSelected,
}) => {
    const isTeacher = useSelector(_isTeacher)

    const commonProps = {
        $isTeacher: isTeacher,
        $isCorrect: isCorrect,
        $numParticipantsSelected: numParticipantsSelected,
        $totalParticipants: totalParticipants,
    }

    const memoizedChoice = useMemo(() => <MathJaxComponent text={content} />, [
        content,
    ])

    const shouldRenderForStudent = !isTeacher && (isSelected || isCorrect)
    const participantsSelected =
        numParticipantsSelected > 0 ? (
            numParticipantsSelected
        ) : isCorrect ? (
            <img src={`${assetsBase}/correct.svg`} alt="green-tick" />
        ) : null
    if (isTeacher || shouldRenderForStudent)
        return (
            <Styles.Container>
                <Styles.SelectionBackground {...commonProps} />
                <Styles.ContentContainer>
                    <Styles.LeftContainer>
                        <Styles.OptionName {...commonProps}>
                            <Text level="3">{choiceOptionMap[option]}</Text>
                        </Styles.OptionName>
                        <Styles.ChoiceContent>
                            <Text color="black" bold={!isTeacher}>
                                {memoizedChoice}
                            </Text>
                        </Styles.ChoiceContent>
                    </Styles.LeftContainer>

                    {isTeacher ? (
                        <Styles.RightContainer>
                            <Styles.Participants>
                                <Text color="rgba(0, 0, 8, 0.5)" level="3">
                                    {participantsSelected}
                                </Text>
                            </Styles.Participants>
                        </Styles.RightContainer>
                    ) : null}
                </Styles.ContentContainer>
            </Styles.Container>
        )

    return null
}

export default Choice
